"use client";

import { SignUpButton } from "@clerk/react";
import { Button, type SxProps, type Theme } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { type FC } from "react";

import { useAuthRedirectUrl } from "~/feature/auth/hooks/useAuthRedirectUrl";
import { useSignUpUnsafeMetadata } from "~/feature/auth/hooks/useSignUpUnsafeMetadata";

interface IAppSignUpButtonProps {
  name?: string;
  sx?: SxProps<Theme>;
  isOutlinedInDarkMode?: boolean;
}

export const AppSignUpButton: FC<IAppSignUpButtonProps> = ({
  name = "Sign Up",
  sx,
  isOutlinedInDarkMode = false,
}) => {
  const theme = useTheme();
  const unsafeMetadata = useSignUpUnsafeMetadata();
  const redirectUrl = useAuthRedirectUrl();

  const buttonVariant =
    theme.palette.mode === "dark" && isOutlinedInDarkMode
      ? "outlined"
      : "contained";

  return (
    <SignUpButton
      mode="modal"
      forceRedirectUrl={redirectUrl}
      unsafeMetadata={unsafeMetadata}
    >
      <Button size="small" variant={buttonVariant} color="primary" sx={sx}>
        {name}
      </Button>
    </SignUpButton>
  );
};
